import { createAsyncActions } from '../../utils';

export const sessionConstants = {
  USER_LOGIN: createAsyncActions('@@session/LOGIN'),
  SET_SESSION_DATA: '@session/SET_SESSION_DATA',
  USER_LOGOUT: '@@session/USER_LOGOUT',

};
export const sessionActions = {
  userLogin: (payload, meta = {}) => ({
    type: sessionConstants.USER_LOGIN.TRIGGER,
    payload,
meta,
  }),
setSessionData: (payload, meta = {}) => ({
    type: sessionConstants.SET_SESSION_DATA,
    payload,
meta,
  }),
  userLogout: () => ({
    type: sessionConstants.USER_LOGOUT,
  }),
};
